export const GOOGLE_CLIENT_ID = '155034806867-8ngcs20radjg75vmft3eraed822u1slj.apps.googleusercontent.com';
